import { render, staticRenderFns } from "./PropertiesSearch2025.vue?vue&type=template&id=5504a82b"
import script from "./PropertiesSearch2025.vue?vue&type=script&lang=js"
export * from "./PropertiesSearch2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports